import { Link } from 'react-router-dom';
import LegalLayout from '@/components/LegalLayout';
import { BUSINESS } from '@/lib/legal';

export default function Terms() {
  return (
    <LegalLayout
      title="Terms of Service"
      intro={`These terms govern your use of the ${BUSINESS.brand} website, mobile app, and account. By creating an account or buying a plan, you agree to them.`}
    >
      <h2>1. Your account</h2>
      <p>
        You must provide accurate information and keep your password secure. You are responsible for activity on
        your account. One account per person. You must be old enough to form a binding contract in{' '}
        {BUSINESS.region}.
      </p>

      <h2>2. What a "subscription" means</h2>
      <p>
        A {BUSINESS.brand} subscription is a <strong>prepaid package</strong> of a fixed number of tiffins ("credits")
        that stays valid for a set number of days. <strong>It is not an auto-renewing subscription</strong> — we do
        not automatically charge your card again. When your credits run out or the validity period ends, you simply
        choose whether to buy a new plan or top up. Nothing renews on its own.
      </p>

      <h2>3. Using your tiffins</h2>
      <ul>
        <li>Each account has a personal QR pass. Show it at our pickup counter and one credit is deducted per tiffin.</li>
        <li>Tiffins are available during our posted hours and subject to daily availability. Our menu rotates daily and specific dishes are not guaranteed.</li>
        <li>Credits are tied to your account and are not transferable or redeemable for cash except as described in our <Link to="/refunds">Refund &amp; Cancellation Policy</Link>.</li>
      </ul>

      <h2>4. Payment &amp; activation</h2>
      <p>
        New plans and top-ups start as <strong>pending</strong> until payment is confirmed. Online payments are
        processed by Square and activate once confirmed; in-store payments activate once our staff confirm them.
        See our <Link to="/payment-terms">Payment &amp; Subscription Terms</Link> for details.
      </p>

      <h2>5. Pricing &amp; menu</h2>
      <p>
        Prices are shown in Canadian Dollars (CAD) and may change over time; the price you paid for an active plan
        does not change mid-term. Our menu is prepared fresh and varies day to day.
      </p>

      <h2>6. Acceptable use</h2>
      <p>You agree not to misuse the service, including:</p>
      <ul>
        <li>Sharing your QR pass to let others redeem your credits fraudulently, or reselling tiffins.</li>
        <li>Attempting fraudulent payments, chargebacks in bad faith, or gaming discount codes.</li>
        <li>Interfering with, or attempting to gain unauthorized access to, our systems.</li>
      </ul>

      <h2>7. Suspension &amp; termination</h2>
      <p>
        We may suspend or close an account for misuse, non-payment, or fraud. You may stop using the service and
        delete your account at any time via <Link to="/delete-account">Delete My Account</Link>.
      </p>

      <h2>8. Food &amp; allergies</h2>
      <p>
        Our food is prepared in a kitchen that handles common allergens. If you have allergies or dietary
        restrictions, please check with us before ordering.
      </p>

      <h2>9. Disclaimers &amp; liability</h2>
      <p>
        The service is provided "as is". To the fullest extent permitted by law, {BUSINESS.legalName} is not liable
        for indirect or consequential damages, and our total liability is limited to the amount you paid for the
        plan in question.
      </p>

      <h2>10. Governing law</h2>
      <p>These terms are governed by the laws of {BUSINESS.region}.</p>

      <h2>11. Changes &amp; contact</h2>
      <p>
        We may update these terms and will post the new version here. Questions? Email{' '}
        <a href={`mailto:${BUSINESS.supportEmail}`}>{BUSINESS.supportEmail}</a>.
      </p>
    </LegalLayout>
  );
}
